"use client";

import { useStatisticsConsent } from "@/legal/cookie-consent/useCookiebotConsent";
import { applyPostHogConsent } from "./config";

/**
 * Keeps PostHog capturing in sync with Cookiebot "statistics" consent.
 * PostHog initialises in cookieless mode, so nothing is persisted until
 * consent is granted here. Outside production Cookiebot is never loaded, so
 * capturing is enabled without consent — see `applyPostHogConsent`.
 */
export default function PostHogConsentSync() {
  useStatisticsConsent(applyPostHogConsent);
  return null;
}
